export const accessRequestTranslations = {
  loading: {
    key: 'accessRequest.loading',
    defaultValue: 'Fetching requests . . .',
  },
  error: {
    key: 'accessRequest.error',
    defaultValue: 'There was an error while fetching the Requests. Please try again later!',
  },
  noData: {
    key: 'accessRequest.noData',
    defaultValue: 'No requests found!',
  },
  totalActions: {
    key: 'accessRequest.totalActions',
    defaultValue: 'Total Actions',
  },
  pendingActions: {
    key: 'accessRequest.pendingActions',
    defaultValue: 'In Review',
  },
  expiringIn5DaysActions: {
    key: 'accessRequest.expiringIn5DaysActions',
    defaultValue: 'Expiring in 5 Days',
  },
  approvedActions: {
    key: 'accessRequest.approvedActions',
    defaultValue: 'Approved',
  },
  rejectedActions: {
    key: 'accessRequest.rejectedActions',
    defaultValue: 'Rejected',
  },
  expiredActions: {
    key: 'accessRequest.expiredActions',
    defaultValue: 'Expired',
  },
  daysLeftText: {
    key: 'accessRequest.daysLeftText',
    defaultValue: 'days left',
  },
  email: {
    key: 'accessRequest.email',
    defaultValue: 'Email',
  },
  status: {
    key: 'accessRequest.status',
    defaultValue: 'Status',
  },
  statusTimestamp: {
    key: 'accessRequest.statusTimestamp',
    defaultValue: 'Status Timestamp',
  },
  requestedTimestamp: {
    key: 'accessRequest.requestedTimestamp',
    defaultValue: 'Requested Timestamp',
  },
  accessRequestId: {
    key: 'accessRequest.accessRequestId',
    defaultValue: 'Access Request ID',
  },
  manageAccessModal: {
    reviewRequest: {
      key: 'accessRequest.manageAccessModal.reviewRequest',
      defaultValue: 'Review Request',
    },
    modifyRequest: {
      key: 'accessRequest.manageAccessModal.modifyRequest',
      defaultValue: 'Modify Request',
    },
    rejectAccess: {
      key: 'accessRequest.manageAccessModal.rejectAccess',
      defaultValue: 'Reject Access',
    },
    approveAccess: {
      key: 'accessRequest.manageAccessModal.approveAccess',
      defaultValue: 'Approve Access',
    },
    revokeAccess: {
      key: 'accessRequest.manageAccessModal.revokeAccess',
      defaultValue: 'Revoke Access',
    },
    requestID: {
      key: 'accessRequest.manageAccessModal.requestID',
      defaultValue: 'Request ID',
    },
    role: {
      key: 'accessRequest.manageAccessModal.role',
      defaultValue: 'Role',
    },
    organization: {
      key: 'accessRequest.manageAccessModal.organization',
      defaultValue: 'Organization',
    },
    businessUnit: {
      key: 'accessRequest.manageAccessModal.businessUnit',
      defaultValue: 'Business Unit',
    },
    brand: {
      key: 'accessRequest.manageAccessModal.brand',
      defaultValue: 'Brand',
    },
    approvedSuccessText: {
      key: 'accessRequest.manageAccessModal.approvedSuccessText',
      defaultValue: 'The access request has been approved successfully!',
    },
    rejectedSuccessText: {
      key: 'accessRequest.manageAccessModal.rejectedSuccessText',
      defaultValue: 'The access request has been rejected successfully!',
    },
    approvedErrorText: {
      key: 'accessRequest.manageAccessModal.approvedErrorText',
      defaultValue: 'There was an error while approving the access request. Please try again later!',
    },
    rejectedErrorText: {
      key: 'accessRequest.manageAccessModal.rejectedErrorText',
      defaultValue: 'There was an error while rejecting the access request. Please try again later!',
    },
  },
  triggerNotificationModal: {
    message: {
      key: 'accessRequest.triggerNotificationModal.message',
      defaultValue:
        'The access request for this person has expired. Please send them an email prompting them to submit a new request in order to regain the necessary access.',
    },
    sendEmail: {
      key: 'accessRequest.triggerNotificationModal.sendEmail',
      defaultValue: 'Send Email',
    },
  },
  hi: {
    key: 'accessRequest.hi',
    defaultValue: 'Hi',
  },
  requestAssignmentsStatus: {
    text1: {
      key: 'accessRequest.requestAssignmentsStatus.text1',
      defaultValue: 'Seems like you do not have any stores assigned',
    },
    text2: {
      key: 'accessRequest.requestAssignmentsStatus.text2',
      defaultValue: 'Here are the statuses of your access requests. Please contact your manager for approval.',
    },
  },
};
